import * as React from 'react';
import { isSearchEnhancementsMilestone1Enabled } from 'feature-flags';
import { IconCardLayout } from 'view/layout/icon-card-layout';
import * as grid from 'view/styles/grid';
import { AutoFocus } from '@atlassian/help-center-common-component/auto-focus';
import * as qs from '@atlassian/help-center-common-util/history-qs';
import { Root, Title, SubTitle, TitleContainer } from './styled';

export interface SearchProps {
    queryHash?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    autoFocus?: boolean;
    focusable?: boolean;
}

export interface SearchResultProps extends SearchProps {
    className?: string;
    titleHtml: string;
    to: string;
    openNewTab?: boolean;
    leftIcon?: React.ReactNode;
    subtitle?: React.ReactNode;
    elevated?: boolean;
    rightIcon?: React.ReactNode;
    actionSubjectId: string;
}

const SearchResult: React.StatelessComponent<SearchResultProps> = ({
    leftIcon,
    titleHtml,
    subtitle,
    to,
    openNewTab,
    rightIcon,
    queryHash,
    autoFocus,
    focusable,
    onClick,
    className,
    elevated,
    actionSubjectId,
}) => {
    const content = (
        <TitleContainer>
            <Title dangerouslySetInnerHTML={{ __html: titleHtml }} />
            {subtitle && <SubTitle>{subtitle}</SubTitle>}
        </TitleContainer>
    );

    const result = (
        <Root
            data-test-id="result-base-entry"
            className={className}
            tabIndex={focusable ? 0 : -1}
            to={qs.addParamsToUrl(to, { src: queryHash })}
            onClick={onClick}
            elevated={elevated}
            actionSubjectId={actionSubjectId}
            target={openNewTab ? '_blank' : '_self'}
        >
            <IconCardLayout
                leftIcon={leftIcon}
                rightIcon={rightIcon ? rightIcon : undefined}
                content={content}
                centerAlignLeftIcon
                centerAlignRightIcon
                iconSize={isSearchEnhancementsMilestone1Enabled() ? grid.multiple(3).unitless : undefined}
            />
        </Root>
    );

    if (autoFocus) {
        return <AutoFocus>{result}</AutoFocus>;
    }

    return result;
};

export default SearchResult;
